// src/reducers/priority.js

import { CREATE_PRIORITY, RETRIEVE_PRIORITIES, UPDATE_PRIORITY, DELETE_PRIORITY } from '../actions/types';

const initialState = [];

function priorityReducer(priorities = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case RETRIEVE_PRIORITIES:
            return payload;

        case CREATE_PRIORITY:
            return [...priorities, payload];

        case UPDATE_PRIORITY:
            return priorities.map((priority) => {
                // อ้างอิง primary key จาก model คือ priority_id
                if (priority.priority_id === payload.priority_id) {
                    return payload; // แทนที่ด้วยข้อมูลใหม่ทั้งหมดจาก server
                } else {
                    return priority;
                }
            });

        case DELETE_PRIORITY:
            // payload คือ { id: ... }
            return priorities.filter(({ priority_id }) => priority_id !== payload.id);

        default:
            return priorities;
    }
}

export default priorityReducer;
